
import DishApp from "../components/DishApp";

export default function Dish() {
 return <DishApp />;
}
